export const about_us = {
  description: {
    paragraphs: [
      'Introducing the CryptoDATA RNF MotoGP™ Team - a new era of collaboration that extends beyond racing. Coming from experience and expertise since 2019, the RNF MotoGP Team is set to compete in the premier class of the 2023 FIM MotoGP World Championship grid as the first-ever satellite team for Aprilia with a powerhouse line-up featuring Portuguese MotoGP rider and 2021 Moto2 Vice World Champion, Raul Fernandez.',
      'The partnership with CryptoDATA will not only bring sustainability on and off the track, but also set the tone for the team\'s continued growth and success CryptoDATA will spearhead the business side of operations, while the RNF MotoGP Team remains dedicated to excelling on the track.',
    ]
  }
};
